import { createSelector } from '@reduxjs/toolkit';

export const ParticipantDashboardSelector = (state) => state.ParticipantDashboardReducer;

export const ParticipantDashboardDataSelector = createSelector(
    ParticipantDashboardSelector,
    (state) => {
        return state?.participantDashboard || {};
    }
);

export const ParticipantDashboardErrorSelector = createSelector(
    ParticipantDashboardSelector,
    (state) => {
        return state?.errors || {};
    }
);

export const ParticipantDashboardLoadingSelector = createSelector(
    ParticipantDashboardSelector,
    (state) => {
        return state?.isLoading;
    }
);